import { isPro } from '@/utils/env'

const sensors: any = window['sensorsDataAnalytic201505']

window.sensors = sensors

sensors.init({
  server_url: `https://data.pdnews.cn/sa?project=${isPro() ? 'production' : 'default'}`,
  heatmap: { scroll_notice_map: 'not_collect' },
  batch_send: true,
  use_client_time: true,
  show_log: false,
  send_type: 'beacon'
})
sensors.quick('autoTrack')
